/* sts-state.js - see docs/new-theme-v4/asset-notes/sts-state.md */
(function () {
  'use strict';

  var w = window;
  var STS = (w.STS = w.STS || {});

  /* THE routine-step normaliser: every reader of saved steps goes through it.
     The regimen API sends steps in SLOT order with AM/PM alternating and no
     step number. Why and how: docs/new-theme-v4/asset-notes/sts-state.md */
  function routineTime(raw) {
    var t = String(raw == null ? '' : raw).toUpperCase().replace(/[\s._-]/g, '');
    if (t === 'AM' || t === 'MORNING') return 'AM';
    if (t === 'PM' || t === 'EVENING' || t === 'NIGHT') return 'PM';
    if (t === 'BOTH' || t === 'DAILY' || (/AM/.test(t) && /PM/.test(t))) return 'BOTH';
    return null;
  }
  function stepTime(s) {
    return routineTime(s.time != null && s.time !== '' ? s.time : s.period);
  }
  function stepNo(s) {
    var k = Number(s.step_num != null ? s.step_num : s.n);
    return k > 0 ? k : null;
  }
  /* opts.once: an AM+PM step stays ONE entry (in the morning half), for a
     surface that keys state by index. Otherwise it is listed in both halves,
     as every surface draws it. Each entry is a copy with canonical `time`,
     `half`, a per-half `n` and `srcIndex` (its index in the input). */
  function orderRoutine(steps, opts) {
    var once = !!(opts && opts.once);
    var am = [], pm = [], rest = [];
    (Array.isArray(steps) ? steps : []).forEach(function (s, i) {
      if (!s || typeof s !== 'object') return;
      var c = { s: s, i: i, t: stepTime(s), k: stepNo(s) };
      if (c.t === 'AM' || c.t === 'BOTH') am.push(c);
      if (c.t === 'PM' || (c.t === 'BOTH' && !once)) pm.push(c);
      if (!c.t) rest.push(c);
    });
    var out = [], n = 0;
    function emit(list, half) {
      if (list.every(function (c) { return c.k; })) {
        list.sort(function (a, b) { return (a.k - b.k) || (a.i - b.i); });
      }
      if (half) n = 0;
      list.forEach(function (c) {
        var x = Object.assign({}, c.s);
        if (c.t) x.time = c.t;
        x.half = half || null;
        x.n = ++n;
        x.srcIndex = c.i;
        out.push(x);
      });
    }
    emit(am, 'AM');
    emit(pm, 'PM');
    emit(rest, null);  // no time: keeps counting, as the server tiles do
    return out;
  }
  STS.routineTime = routineTime;
  STS.orderRoutine = orderRoutine;

  /* THE step namer (2026-09-25). The templates' eye step is a placeholder,
     slot ECS "Eye Cream Specific", resolved to E01-E05 from the quiz eye
     answer. Unresolved, it is the eye cream step and that label never prints.
     slotFam: the letters before the digits (CX21 -> CX); ECS or E -> E.
     sameSlot: same code, or the placeholder and any E slot.
     stepLabel(s, keys): first of s[keys] (label, category) that is not the
     placeholder; past one, a real s.indication; else '' (caller's word). */
  var EYE = /^E(CS)?$/;
  function up(v) { return String(v == null ? '' : v).trim().toUpperCase(); }
  function slotFam(slot) {
    var s = up(slot), m = /^[A-Z]+/.exec(s);
    return EYE.test(s) ? 'E' : m ? m[0] : '';
  }
  function sameSlot(a, b) {
    a = up(a); b = up(b);
    return a === b || ((EYE.test(a) || EYE.test(b)) && slotFam(a) === 'E' && slotFam(b) === 'E');
  }
  function placeholder(t, slot) {
    var l = String(t).toLowerCase().replace(/[\s_-]+/g, ' ').trim();
    return l === 'eye cream specific' || EYE.test(up(t)) || (/ specific$/.test(l) && slotFam(slot) === 'E');
  }
  function stepLabel(s, keys) {
    s = s || {};
    var ph = false, i, v;
    keys = keys || ['label', 'category'];
    for (i = 0; i < keys.length; i++) {
      v = s[keys[i]];
      if (v == null || v === '') continue;
      if (!placeholder(v, s.slot)) return String(v);
      ph = true;
    }
    v = s.indication;
    return ph && v && !placeholder(v, s.slot) ? String(v) : '';
  }
  STS.slotFam = slotFam;
  STS.sameSlot = sameSlot;
  STS.stepLabel = stepLabel;

  /* V6-1.4: "Tap" on a touch screen or at 860px and narrower, "Click"
     everywhere else. The same query as the .sts-only-touch / .sts-only-pointer
     pair in assets/sts-tokens.css: markup uses the pair, script-built copy
     calls this. tapClick(1) gives the lower-case word. */
  STS.tapClick = function (lower) {
    var t = !!(w.matchMedia && w.matchMedia('(hover:none),(pointer:coarse),(max-width:860px)').matches);
    return lower ? (t ? 'tap' : 'click') : (t ? 'Tap' : 'Click');
  };

  /* The head snippet resolves without this file, but a page that somehow ships
     one and not the other must not throw for every consumer downstream. */
  if (!STS.state) return;

  var SERVER = w.__STS_SERVER__ || {};

  /* The 16 Baumann codes in their canonical order; typeNumber is the 1-based
     index. Other workstreams validate against this rather than re-typing it. */
  STS.TYPES = STS.TYPES || ['DSPT', 'DSNT', 'DSPW', 'DSNW', 'OSPT', 'OSNT', 'OSPW', 'OSNW',
    'ORPT', 'ORNT', 'ORPW', 'ORNW', 'DRPT', 'DRNT', 'DRPW', 'DRNW'];

  /* Everything identity-shaped, cleared on logout and on an account switch
     (spec §3.6 / §7.8, decision 02-Q13). affiliateCode, fullCodeParam and
     providerId are NOT here and must never be added: affiliate attribution
     survives a logout by decision 03-Q4. */
  var IDENTITY_LOCAL = ['customerSkinType', 'customerSensitivityList', 'customerEmail',
    'customerOid', 'customerRoutine', 'customerQuizAnswers', 'purchasedSkus', 'isLoggedIn',
    'sts_typed_at', 'sts_quiz_progress', 'sts_last_customer_id', 'sts_fresh_type',
    'slqSavedResults', 'slqSavedRegimen'];
  /* slq_result is not in the spec's list; it is here because it is the same
     result blob in a second place, and leaving it behind on a shared device
     would defeat the clear. The check-in snooze is not here either, but it is
     no longer "never cleared": it now names a customer, so assets/sts-logout.js
     sweeps it by prefix on sign-out. See snoozeCheckin below. */
  var IDENTITY_SESSION = ['slqResultsHandoff', 'slq_result'];

  var MS_DAY = 86400000;

  // ------------------------------------------------------------ simulated?

  function simulated() {
    var s = STS.state;
    return !!(s && (s.source === 'preview' || (s.flags && s.flags.preview)));
  }
  STS.isSimulated = simulated;

  // ------------------------------------------------------------- storage

  function ls() { return w.localStorage; }

  function get(key, store) {
    try { return (store || ls()).getItem(key); } catch (e) { return null; }
  }
  function set(key, value, store) {
    try { (store || ls()).setItem(key, value); return true; } catch (e) { return false; }
  }
  function del(key, store) {
    try { (store || ls()).removeItem(key); } catch (e) { /* blocked storage */ }
  }
  function parse(raw) {
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  /* Safari private browsing and blocked cookies make localStorage throw on
     ACCESS, not only on write. The whole engine degrades to Q− in that case,
     which is the safe direction but silently suppresses personalisation for a
     slice of traffic — so the slice is measured (spec risk 8). */
  function storageBlocked() {
    if (STS.storageBlocked != null) return STS.storageBlocked;
    var probe = '__sts__';
    STS.storageBlocked = !set(probe, '1');
    del(probe);
    return STS.storageBlocked;
  }

  // ------------------------------------------------- identity hygiene (§7.8)

  /* Exported: the auth modal and the logout hook both need it, and so does any
     flow that switches accounts. */
  function clearIdentity() {
    var i;
    for (i = 0; i < IDENTITY_LOCAL.length; i++) del(IDENTITY_LOCAL[i]);
    for (i = 0; i < IDENTITY_SESSION.length; i++) del(IDENTITY_SESSION[i], w.sessionStorage);
  }
  STS.clearIdentityKeys = clearIdentity;

  /* Mechanism 2 of §7.8. The head script raised this flag when the server said
     "not logged in" (or "a different customer") while the device still held a
     previous customer's id. That catches session expiry, a logout in another
     tab, and a logout from Shopify's own pages where the click hook never ran.
     The head script has already refused to trust those keys for this render;
     this only removes them. */
  if (STS.clearIdentity) {
    clearIdentity();
    delete STS.clearIdentity;
  }

  /* Mechanism 1 of §7.8: the logout click itself. Capture phase, so a handler
     that stops propagation cannot skip it; the anchor's own href does the
     navigation. */
  document.addEventListener('click', function (ev) {
    var el = ev.target;
    while (el && el !== document) {
      if (el.tagName === 'A') {
        var href = el.getAttribute('href') || '';
        // indexOf, not a prefix match: a localised storefront renders the route
        // as /en-ca/account/logout.
        if (href.indexOf('/account/logout') > -1) clearIdentity();
        return;
      }
      el = el.parentNode;
    }
  }, true);

  // ------------------------------------------ device <- server reconciliation

  /* The metafield wins (§7.1), but not over a newer quiz this customer took
     here (snippets/sts-head-state.liquid, "THE LATEST QUIZ WINS"). The device
     copies are mirrors for legacy scripts, never the source. */
  var FRESH_KEY = 'sts_fresh_type';

  /* The note, while it still outranks the account; dropped once not. */
  function freshType() {
    var rec = parse(get(FRESH_KEY));
    if (!rec) { if (get(FRESH_KEY) != null) del(FRESH_KEY); return null; }
    var live = String(rec.c) === String(SERVER.customerId) &&
      STS.TYPES.indexOf(rec.t) > -1 && Date.now() - rec.at < 30 * MS_DAY &&
      rec.t !== SERVER.type && rec.at > (SERVER.typedTs || 0) * 1000;
    if (!live) { del(FRESH_KEY); return null; }
    return rec;
  }

  function reconcile() {
    if (!SERVER.loggedIn) return;
    if (SERVER.customerId) set('sts_last_customer_id', String(SERVER.customerId));
    var fresh = freshType();
    if (fresh) {
      set('customerSkinType', fresh.t);
      set('sts_typed_at', new Date(fresh.at).toISOString());
      return;
    }
    if (SERVER.type) {
      set('customerSkinType', SERVER.type);
      if (SERVER.typedAt) set('sts_typed_at', SERVER.typedAt);
    }
  }

  /* A guest who has taken the quiz has a type on the device but no sts.typed_at
     metafield to date it. sts-state-quiz-bridge.js stamps sts_typed_at at the
     moment the quiz writes the type; this covers the visitors who typed before
     that shipped, using the saved-results timestamp the quiz already writes.
     Never invents "now" for an untyped visitor, and never overwrites a stamp
     that is already there — a wrong "today" would silently reset a check-in
     clock that is genuinely six months old. */
  function backfillTypedAt() {
    if (SERVER.loggedIn || get('sts_typed_at')) return;
    /* STS.state.type is the simulator's type while a preview is running, and
       this function's whole job is to write a date derived from it. */
    if (simulated()) return;
    if (!STS.state.type) return;
    var saved = parse(get('slqSavedResults'));
    if (saved && saved.savedAt) set('sts_typed_at', new Date(saved.savedAt).toISOString());
  }

  /* §7.3: signed in, no type on the account, but this device holds the widget
     token of a result that was taken while logged out. The Skin Profile (WS05)
     offers "Save this result to my account", which POSTs it to
     /apps/quiz/attach-result and then calls STS.refresh(). */
  function detectPendingAttach() {
    if (!SERVER.loggedIn || SERVER.type) return;
    var saved = parse(get('slqSavedResults'));
    if (saved && saved.widgetToken) {
      STS.pendingAttach = true;
      STS.refresh();
    }
  }

  // ------------------------------------------------------ copy fill (§7.4)

  /* The strip markup belongs to WS03; the numbers in it belong here. Two ways
     to consume them, both idempotent so a refresh() re-fills rather than
     doubling up:

       <span data-sts-quiz-pct></span>          — a slot, filled with the value
       <p data-sts-fill>You are {pct}% done</p> — a template, tokens replaced

     Tokens: {pct} {answered} {next} {total} {remaining} {eta} {months} {type} {typenumber}. */
  function tokens() {
    var s = STS.state;
    var q = s.quiz || {};
    /* Days below 60, months above, no clamp: sff_since in
       snippets/sts-server-facts.liquid spells the rule and why. */
    /* Two clocks, deliberately separate. {months} is the QUIZ clock and the
       check-in card is right to use it. {ordermonths} is the ORDER clock, and
       every Q+ stale sentence must use that one - qstale is decided by
       last_order alone, so a line written against the quiz clock tells a
       customer who took the quiz this morning to retake it, and retaking can
       never clear the state. That shipped; see N53. */
    function ageWords(iso) {
      if (!iso) return '';
      var age = (Date.now() - Date.parse(iso)) / MS_DAY;
      if (!(age > 0)) return '';
      var d = Math.floor(age), n = d < 60 ? d : Math.round(age / 30.44);
      return age < 1 ? 'less than a day'
        : n + (d < 60 ? ' day' : ' month') + (n === 1 ? '' : 's');
    }
    var months = ageWords(s.typedAt);
    var orderMonths = ageWords(s.lastOrderAt);
    return {
      pct: q.pct == null ? '' : String(q.pct),
      answered: q.answered == null ? '' : String(q.answered),
      total: q.total == null ? '' : String(q.total),
      remaining: q.remaining == null ? '' : String(q.remaining),
      /* {next} is the question they resume AT; {eta} is 18s a question, the
         prototype's own rate (5 left = "About 90 seconds"). */
      next: q.answered == null ? '' : String(Math.min(q.answered + 1, q.total || 1e9)),
      eta: q.remaining == null ? '' : (q.remaining * 18 < 120 ? Math.max(10, Math.round(q.remaining * 1.8) * 10) + ' seconds' : Math.round(q.remaining * .3) + ' minutes'),
      months: months,
      ordermonths: orderMonths,
      type: s.type || '',
      typenumber: s.typeNumber == null ? '' : String(s.typeNumber)
    };
  }

  var SLOTS = {
    pct: 'quiz-pct', answered: 'quiz-answered', total: 'quiz-total',
    remaining: 'quiz-remaining', months: 'checkin-months', ordermonths: 'order-months',
    type: 'type-code', typenumber: 'type-number'
  };

  function fill() {
    var t = tokens();
    var key;
    for (key in SLOTS) {
      if (!Object.prototype.hasOwnProperty.call(SLOTS, key)) continue;
      var slots = document.querySelectorAll('[data-sts-' + SLOTS[key] + ']');
      for (var i = 0; i < slots.length; i++) slots[i].textContent = t[key];
    }
    var tpl = document.querySelectorAll('[data-sts-fill]');
    for (var j = 0; j < tpl.length; j++) {
      var el = tpl[j];
      /* Liquid bakes the customer's own type into signed-in copy; turn it back
         into {type} so the RESOLVED state (the simulator, a new quiz) fills it,
         as the badge does. */
      if (el.__stsTpl == null) el.__stsTpl = SERVER.type ? el.textContent.split(SERVER.type).join('{type}') : el.textContent;
      el.textContent = el.__stsTpl.replace(/\{(\w+)\}/g, function (m, name) {
        var v = t[String(name).toLowerCase()];
        return v == null ? m : v;
      });
    }
  }

  // --------------------------------------------------------- check-in snooze

  function snoozeKey() {
    return STS.snoozeKey || ('sts_checkin_snooze_' + (SERVER.customerId || 'guest'));
  }

  STS.snoozeCheckin = function (days) {
    var until = Date.now() + (days || 30) * MS_DAY;
    /* Dismissing a strip that is only on screen because it was simulated must
       not snooze the real one for the next 30 days. The × still works — the
       strip is dismissed with the same attribute assets/sts-chrome.js uses when
       this function is missing entirely — it just leaves nothing behind, and
       the next reload brings the simulated strip back, which is correct: the
       preview has no memory either. */
    if (simulated()) {
      document.documentElement.setAttribute('data-sts-strip', 'dismissed');
      /* Say so. Until this line, the guard was correct and completely silent,
         and the only route a reviewer has into a check-in-due state is the
         simulator — so the one thing they can observe is a dismissal that does
         not survive the next page, which reads exactly like the bug it is the
         defence against. It was reported as one (QA, 2026-09-19). A tester
         cannot tell a working guard from a broken snooze without being told
         which they are looking at, so this tells them, and points at the only
         session that can answer the question. */
      try {
        console.info('[sts] Check-in reminder dismissed for THIS PAGE ONLY. The ' +
          'state is simulated (?sts_preview=), so no snooze was written and the ' +
          'strip returns on the next page. That is deliberate: a previewed state ' +
          'must never silence the reminder of a real customer for 30 days. To test ' +
          'that a dismissal persists, sign in as a customer whose quiz is at ' +
          'least ' + (SERVER.checkinDays || 182) + ' days old and dismiss it with ' +
          'no sts_preview parameter in the URL.');
      } catch (e) { /* never break a page */ }
      return until;
    }
    set(snoozeKey(), String(until));
    STS.refresh();
    return until;
  };

  // ------------------------------------------------- the simulated routine

  function onMain() {
    try {
      return String((w.Shopify && w.Shopify.theme && w.Shopify.theme.role) || '').toLowerCase() === 'main';
    } catch (e) { return false; } /* no Shopify global: the simulator's own gate still applies */
  }
  function previewRoutineNow() {
    if (onMain()) return null;
    var p = STS.preview;
    var r = p && p.active && p.regimen;
    return (r && r.fixture === true && r.steps && r.steps.length) ? r : null;
  }

  /* Has this session asked for one? The URL parameter, a typed row in the
     URL (q[ncsg]: asset-notes/sts-state.md), or the selection the simulator
     parked in sessionStorage so a fixture survives a page change. A typed
     row with No routine asks too: its answer is "none", never the account's. */
  function previewRoutineAsked() {
    if (onMain()) return false;
    try {
      if (/[?&]sts_(routine=|preview=q[ncsg])/.test(w.location.search)) return true;
      var raw = w.sessionStorage.getItem('sts_preview');
      var sel = raw ? JSON.parse(raw) : null;
      return !!(sel && (sel.type || (sel.routine && sel.routine !== 'off')));
    } catch (e) { return false; }
  }

  /* THE visit's routine: sessionStorage sts.addrt {t, o, steps, extras,
     quantities, routineSize}, the routine whenever it is not saved to the
     account - the simulator (o 'sim') and a signed-in customer while saving is
     off (o 'c<id>'). Add to my routine (assets/sts-add-routine.js) and the
     Skin Profile write it, and previewRoutine() below hands it out first, so a
     change made on one page is the routine on every page of the visit. A
     guest's routine is the device copy instead, a saved one the account's. */
  var VISIT = 'sts.addrt';
  function visitSim() { return !!(STS.preview && STS.preview.active) || simulated() || previewRoutineAsked(); }
  function visitOwner() { return visitSim() ? 'sim' : SERVER.customerId ? 'c' + SERVER.customerId : null; }
  function visitType() { return String((STS.state && STS.state.type) || document.documentElement.getAttribute('data-sts-type') || '').toUpperCase(); }
  /* A copy made for another skin type (a retake, the simulator's type
     changed) is gone, not just skipped. */
  function visitDrop() {
    var t = visitType(), v = null;
    if (!t) return;
    try { v = JSON.parse(w.sessionStorage.getItem(VISIT) || 'null'); } catch (e) { return; }
    if (v && v.t && v.t !== t) { try { w.sessionStorage.removeItem(VISIT); } catch (e) { /* blocked */ } }
  }
  document.addEventListener('sts:state', visitDrop);
  STS.visitRoutine = {
    sim: visitSim,
    get: function () {
      var o = visitOwner(), v = null;
      visitDrop();
      if (!o) return null;
      try { v = JSON.parse(w.sessionStorage.getItem(VISIT) || 'null'); } catch (e) { return null; }
      return v && v.o === o && v.t === visitType() && Array.isArray(v.steps) && v.steps.length ? v : null;
    },
    save: function (r) {
      var o = visitOwner();
      if (!o || !r || !Array.isArray(r.steps)) return;
      try {
        w.sessionStorage.setItem(VISIT, JSON.stringify({ t: visitType(), o: o, steps: r.steps, extras: r.extras || [],
          quantities: r.quantities || null, routineSize: r.routineSize || null, sensitivity: r.sensitivity || null }));
      } catch (e) { /* storage blocked: this page only */ }
    }
  };
  /* The visit's copy, over the simulator's fixture it started from. */
  function withVisit(fx) {
    var v = STS.visitRoutine.get();
    return v ? Object.assign({}, fx || {}, v, { skinType: v.t, visit: true }) : fx;
  }

  STS.previewRoutine = function () {
    return previewRoutineBase().then(withVisit);
  };
  function previewRoutineBase() {
    var now = previewRoutineNow();
    if (now || !previewRoutineAsked() || document.readyState === 'complete') {
      return Promise.resolve(now);
    }
    /* NOT `readyState === 'loading'`: a deferred script runs when the document
       is already 'interactive', so that test was false for every caller here
       and the wait never happened — the first build of this went straight past
       the fixture and redirected to the quiz. DOMContentLoaded fires after the
       last deferred script, which is the simulator, so it is the right barrier;
       `load` and the cap are there so a call made in the window between those
       two events cannot hang a page. */
    return new Promise(function (resolve) {
      var done = function () { resolve(previewRoutineNow()); };
      document.addEventListener('DOMContentLoaded', done, { once: true });
      w.addEventListener('load', done, { once: true });
      w.setTimeout(done, 3000);
    });
  }

  /* The synchronous half, for the one caller that has to decide whether to
     start at all before it can afford to wait: the Skin Profile, whose routine
     column is signed-in-only and must stay that way for everybody else. */
  STS.previewRoutine.asked = previewRoutineAsked;

  // -------------------------------------------------- redirects under preview

  var PREVIEW_PARAMS = ['sts_preview', 'sts_type', 'sts_answered', 'sts_pct',
    'sts_checkin', 'sts_routine', 'sts_budget', 'preview_theme_id'];

  STS.keepPreview = function (url) {
    var carry = [];
    try {
      var here = new URLSearchParams(w.location.search);
      for (var i = 0; i < PREVIEW_PARAMS.length; i++) {
        var k = PREVIEW_PARAMS[i], v = here.get(k);
        // Never clobber a parameter the target URL already sets for itself.
        if (v != null && url.indexOf(k + '=') < 0) {
          carry.push(k + '=' + encodeURIComponent(v));
        }
      }
    } catch (e) { return url; }
    if (!carry.length) return url;
    // Any #fragment stays last, where it belongs.
    var h = url.indexOf('#'), hash = h > -1 ? url.slice(h) : '';
    if (h > -1) url = url.slice(0, h);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + carry.join('&') + hash;
  };

  /* v6.1 1.1, one See my routine rule: signed in -> Skin Profile at Your
     routine; a typed guest (no routine column there) -> results. Keyed on
     STS.state.loggedIn, so simulator rows follow (qguest is the signed-out
     one). snippets/sts-routine-url.liquid prints the same server side;
     [data-sts-routine-link] is re-pointed on a state change and on click. */
  STS.routineUrl = function () {
    return STS.keepPreview((STS.state || {}).loggedIn ? '/pages/skin-profile#my-routine' : '/pages/skin-type-results');
  };
  function routineLinks(e) {
    var a = e ? [e.target.closest && e.target.closest('[data-sts-routine-link]')] : document.querySelectorAll('[data-sts-routine-link]');
    for (var i = 0; i < a.length; i++) if (a[i]) a[i].href = STS.routineUrl();
  }
  /* STS-ROUTINE-MISSING-1014: See my routine OPENS the routine where the page
     has the My routine widget (every shop page and the homepage): a typed
     visitor always has a routine there (assets/sts-type-routine.js). Marla's
     tap went to the results page instead. The link above stays the way out:
     a new tab / modified click follows it, and so does a page without the
     widget or a widget with nothing to show. A menu or cart drawer the link
     sits in closes first, so the panel is not left under it. */
  function closeAround(a) {
    var C = STS.chrome;
    if (C && C.close) { try { C.close(); } catch (x) { /* the menu's own */ } }
    var box = a.closest && a.closest('[role=dialog],[aria-modal=true],[class*="lcu-"],[id*="lcu"]');
    if (!box) return;
    var x = [].slice.call(box.querySelectorAll('button,[role=button]')).filter(function (b) {
      return /close/i.test((b.getAttribute('aria-label') || '') + ' ' + (b.className || '')) && b.getClientRects().length;
    })[0];
    if (x) x.click();
  }
  function openRoutine(e) {
    if (e.type !== 'click' || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('[data-sts-routine-link]');
    var W = STS.routineWidget;
    if (!a || !W || typeof W.open !== 'function' || !(STS.state || {}).typed || a.target === '_blank') return;
    e.preventDefault();
    var href = a.href;
    closeAround(a);
    W.open({}).then(function (ok) { if (!ok) w.location.href = href; }, function () { w.location.href = href; });
  }

  // ------------------------------------------------------------- analytics

  /* §7.11. The five-state name and two booleans, once per page. No skin type,
     no concerns, no quiz answers — not here and not in any ad pixel.

     And nothing at all when the state is simulated. A staff walk-through of the
     six rows would otherwise arrive in GA4 as six real sessions in six different
     states, indistinguishable from customers; the one place that is visible is a
     funnel report months later, when nobody can say which numbers were people.
     assets/sts-track.js suppresses the same way at its own transport, so the
     rule holds whichever module a surface goes through. */
  function emit() {
    if (simulated()) return;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
      event: 'sts_state',
      sts_state: STS.state.name,
      sts_logged_in: STS.state.loggedIn,
      sts_guest: STS.state.guest,
      sts_storage_blocked: storageBlocked()
    });
  }

  // ------------------------------------------------------------------- boot

  reconcile();
  backfillTypedAt();
  fill();
  document.addEventListener('sts:state', fill);
  routineLinks();
  document.addEventListener('sts:state', function () { routineLinks(); });
  document.addEventListener('click', routineLinks, true);
  document.addEventListener('click', openRoutine, true);
  document.addEventListener('auxclick', routineLinks, true);
  detectPendingAttach();
  emit();
}());
